const breakpoints: { [key: string]: any } = {
  xs: 0,
  sm: 600,
  md: 900,
  md2: 1100,
  lg: 1200,
  lg2: 1300,
  xl: 1536,
}

export default breakpoints
